import Vue from 'vue';

const success = (response, context) => {
    context.user = response.data.user;
    context.userRentals = response.data.user.user_rentals;
    context.userRights = response.data.user.rights[0];
    context.loading = false;
    context.allRentals = response.data.allRentals;
    context.stripeAccounts = response.data.stripeAccounts;

    if(context.allRentals.length > 0) {
      let length = context.allRentals.length;
      for(let i = 0; i < length; i++) {
        let index = context.userRentals.findIndex(x => x.rental_id === context.allRentals[i].id);
        if(index !== -1) {
          //
        }else {
          let data = {
            access: 0,
            rental: context.allRentals[i],
            rental_id: context.allRentals[i].id,
            user_id: context.user.id
          };
          Vue.set(context.userRentals, context.userRentals.length, data);
        }
      }
    }
    context.getUserBillingInfo();
    context.loading = false;
};

const failed = (error, context) => {
    context.showToasterError(error);
    Vue.router.push({
      name: 'account.team',
    });
    context.loading = false;
};

export default (context, id) => {
    return Vue.$http.get(`/team-members/${id}`)
        .then((response) => {
            if (response && response.status === 200) {
                success(response, context);
            } else {
                failed();
            }
        })
        .catch((error) => {
            failed(error, context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/team_member/fetch.js